<template>
  <div class="hc-schedule-table-wrap">

    <b-table
      hover
      responsive
      class="hc-table-clean"
      style="white-space: nowrap; max-width: 100%"
      :items="items"
      :fields="fields">
      <template #table-colgroup="scope">
        <col
          v-for="field in scope.fields"
          :key="field.key"
          :style="{ width: field.key === 'actions' ? '100px' : '' }" />
      </template>

      <!-- Day Name Badge -->
      <template #cell(day_name)="data">
        <span class="hc-day-badge">
          <i class="far fa-calendar-alt mr-1"></i>
          {{ data.item.day_name }}
        </span>
      </template>

      <!-- Start Time -->
      <template #cell(start_time)="data">
        <span class="hc-time-badge hc-time-badge--start">
          <i class="far fa-clock mr-1"></i>
          {{ data.item.start_time }}
        </span>
      </template>

      <!-- End Time -->
      <template #cell(end_time)="data">
        <span class="hc-time-badge hc-time-badge--end">
          <i class="far fa-clock mr-1"></i>
          {{ data.item.end_time }}
        </span>
      </template>

      <!-- Duration -->
      <template #cell(duration)="data">
        <span class="hc-duration-chip">
          {{ data.item.duration }} Menit
        </span>
      </template>

      <!-- Actions -->
      <template #cell(actions)="data">
        <div class="d-flex align-items-center gap-2">
          <button
            type="button"
            class="btn btn-sm btn-icon hc-btn-action-delete"
            v-b-tooltip.hover
            title="Hapus"
            v-if="manipulateBtn == true"
            @click="btnDeleteOnClick(data.item.id)">
            <i class="fas fa-trash-alt"></i>
          </button>
        </div>
      </template>
    </b-table>

    <data-table-pagination
      v-if="items.length != 0"
      :page="currentPage"
      :total-rows="totalRows"
      :per-page="perPage || 20"
      @change="pageOnClick" />

  </div>
</template>

<script>

import DataTablePagination from '@/component/common/DataTablePagination.vue'

export default {

  components: {
    DataTablePagination
  },

  props: {
    fields: Array,
    items: Array,
    hasDoctor: Boolean,
    perPage: Number,
    currentPage: Number,
    totalRows: Number
  },

  data() {
    return {
      manipulateBtn: false,
    }
  },

  methods: {

    pageOnClick(page) {
      this.$emit('pageOnClick', page)
    },

    btnEditOnClick(id) {
      this.$emit('btnEditOnClick', id)
    },

    btnDeleteOnClick(id) {
      this.$emit('btnDeleteOnClick', id)
    },

    // access management
    async setActiveMenu() {
      let access_right_user = window.localStorage.getItem("access_right_display")
      let access_right = JSON.parse(access_right_user)
      let a
      for (a = 0; a < access_right.length; a++) {
        if (access_right[a] == "4002") {
          this.manipulateBtn = true
        }
      }
    }

  },

  mounted() {
    this.setActiveMenu()
  }

}
</script>

<style lang="scss" scoped>
.hc-schedule-table-wrap {
  position: relative;
}

.hc-filter-label {
  display: block;
  margin-bottom: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #475569;

  i {
    color: #1e958f;
  }
}

.hc-day-badge {
  display: inline-flex;
  align-items: center;
  padding: 5px 12px;
  border-radius: 20px;
  background: #f1f5f9;
  color: #1e293b;
  font-size: 12px;
  font-weight: 600;

  i {
    color: #1e958f;
  }
}

.hc-time-badge {
  display: inline-flex;
  align-items: center;
  padding: 5px 10px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;

  &--start {
    background: rgba(30, 149, 143, 0.08);
    color: #1e958f;
  }

  &--end {
    background: rgba(20, 96, 143, 0.08);
    color: #14608f;
  }
}

.hc-duration-chip {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 6px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  color: #64748b;
  font-size: 12px;
  font-weight: 600;
}

.hc-btn-action-delete {
  width: 34px !important;
  height: 34px !important;
  border-radius: 8px !important;
  border: 1px solid rgba(239, 68, 68, 0.2) !important;
  background: rgba(239, 68, 68, 0.08) !important;
  color: #ef4444 !important;
  transition: all 0.2s ease !important;

  &:hover {
    background: #ef4444 !important;
    color: #ffffff !important;
    border-color: #ef4444 !important;
    transform: translateY(-1px);
    box-shadow: 0 4px 10px rgba(239, 68, 68, 0.25) !important;
  }
}
</style>
